var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlayerNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85 6.854l13.333 8.003a1.333 1.333 0 010 2.286l-13.333 8A1.334 1.334 0 015.83 24V7.997a1.334 1.334 0 012.02-1.143zm16.646 1.813a1.332 1.332 0 112.667 0v14.666a1.332 1.332 0 11-2.667 0V8.667z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml,%3Csvg width='33' height='32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m7.85 6.854 13.333 8.003a1.333 1.333 0 0 1 0 2.286l-13.333 8A1.334 1.334 0 0 1 5.83 24V7.997a1.334 1.334 0 0 1 2.02-1.143zm16.646 1.813a1.332 1.332 0 1 1 2.667 0v14.666a1.332 1.332 0 1 1-2.667 0V8.667z' fill='%23fff'/%3E %3C/svg%3E";
export { SvgIcPlayerNext as ReactComponent };